import { render, staticRenderFns } from "./puContractRpeortList.vue?vue&type=template&id=0145c759"
import script from "./puContractRpeortList.vue?vue&type=script&lang=js"
export * from "./puContractRpeortList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports